export class IoC {
    //we can bind a type to many key, in this dictionary we just store the information which type belongs to the given keys
    private typeToKeyDictionary: { [key: string]: any } = {};
    //we store here the singleton instances ot the given type
    private singletonInstanceDictionary: { [typeName: string]: any } = {};

    private thirdPartyInstanceDictionary: { [key: string]: any } = {};

    public getAllTypeToKeyDictionary(): { [key: string]: any } {
        return this.typeToKeyDictionary;
    }

    //we can't really get the T if the function declaration is this: public get<T>(key: string): T
    //T is an interface, problem 1: we cant get the name of the T in typescript, problem 2 we do not have interface the translated javascript code, that is lost during the TS-> JS transformation
    //so we use any.
    //If anyone can provide a typesafe solution without any extra code beside this function, gogo
    public get(key: string): any {
        //check if there were any binding
        let type: any = this.typeToKeyDictionary[key];
        if (!type) {
            throw new Error('Type has not been binded yet: ' + key);
        }

        //ensure to create only an instance to the type only once, does not matter how many bind to key has happened
        if (!this.singletonInstanceDictionary[type.name]) {
            let instance: any = new type();
            this.singletonInstanceDictionary[type.name] = instance;
            if (instance['lateBindIoC']) {
                instance['lateBindIoC']();
            }
        }

        return this.singletonInstanceDictionary[type.name];
    }

    public bindSingletonType<T>(key: string, type: { new (): T }): void {
        if (this.typeToKeyDictionary[key]) {
            throw new Error('Type already binded to the key ' + key);
        }
        this.typeToKeyDictionary[key] = type;
    }

    public rebindSingletonType<T>(key: string, type: { new (): T }): void {
        this.unbindSingletonType(key);
        this.bindSingletonType(key, type);
    }

    public setSingletonType(targetKey: string, sourceKey: string): void {
        this.typeToKeyDictionary[targetKey] = this.typeToKeyDictionary[sourceKey];
    }

    public unbindSingletonType(key: string): void {
        this.typeToKeyDictionary[key] = null;
    }

    public bindThirdPartyInstance(key: string, thirdPartyInstance: any) {
        if (!thirdPartyInstance) {
            throw new Error('ThirdPartyInstance is null' + key);
        }
        if (this.thirdPartyInstanceDictionary[key]) {
            throw new Error('Type already binded to the third party key ' + key);
        }
        this.thirdPartyInstanceDictionary[key] = thirdPartyInstance;
    }

    public getThirdPartyInstance(key: string): any {
        if (!this.thirdPartyInstanceDictionary[key]) {
            throw new Error('Type has not binded to the third party key ' + key);
        }
        return this.thirdPartyInstanceDictionary[key];
    }
}
